import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';
import TravelPurposeThemeCMSModel from '@/visa-application/models/TravelPurposeThemeCMSModel';

export default class TravelPurposeThemeDisplayOrderCMSModel implements CMSModel {
  vac: ApplicationCenterCMSModel = new ApplicationCenterCMSModel();
  travel_purpose_theme: TravelPurposeThemeCMSModel = new TravelPurposeThemeCMSModel();
  weight: number;
  description = '';
  title = '';

  map(obj: any): void {
    this.vac.map(_.get(obj, 'vac', {}));
    this.travel_purpose_theme.map(_.get(obj, 'travel_purpose_theme', {}));
    this.weight = _.get(obj, 'weight', 0);
    this.description = _.get(obj, 'translation[0].description', '');
    this.title = _.get(obj, 'translation[0].title', '');
  }
}
